var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.racing_round_id)?_c(_vm.current,{tag:"component"}):_c('el-alert',{attrs:{"title":"请选择回合","type":"info","show-icon":"","closable":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }